import axios from 'axios';
export const addProposal = (data) => {
	return axios
		.post(`${process.env.REACT_APP_API}/add-proposal`, data, {})
};
